export const Legal_Information_Enums = 
Object.freeze ({
	AML_Policy: 'AML_Policy',
	Privacy_Policy: 'Privacy_Policy',
	Responsible_Gaming: 'Responsible_Gaming',
	Terms_and_Conditions: 'Terms_and_Conditions',
	Terms_and_Conditions_NetEnt: 'Terms_and_Conditions_NetEnt'
});